export interface CareFakedoorModalProps {
  type: CareFakedoorActions
}

export enum CareFakedoorActions {
  CREATE_REMINDER = 'CREATE_REMINDER',
  REGISTER_EXAM_OR_APPOINTMENT = 'REGISTER_EXAM_OR_APPOINTMENT',
}

export enum CareFakedoorSteps {
  UNAVAILABLE_FEATURE = 0,
  SEND_FEEDBACK = 1,
  SENDED_FEEDBACK = 2,
}
